import Vue from 'vue'
import {NOTIFICA_SUCCESSO, NOTIFICA_ERRORE} from '../costanti'

declare var FB

export default {
    namespaced: true,
    state: {
        token_id: '',
        loginSuccessful: false
    },
    getters: {
        isAuthenticated: (state: any) => state.token_id !== ''
    },
    mutations: {
        LOGIN: (state: any, token: any) => {
            // token gets set in state and local storage
            state.token_id = token
            // sets axios to use token by default for every call
            Vue.axios.defaults.headers.common.Authorization = `Token ${token}`
            //
            state.loginSuccessful = true
        },

        LOGOUT: (state: any) => {
            state.token_id = ''
            Vue.axios.defaults.headers.common.Authorization = ''
        },

        SET_LOGIN_SUCCESSFUL: (state: any, value: any) => (state.loginSuccessful = value)
    },
    actions: {
        async login({commit, dispatch}: any, dispatchParams: any) {
            try {
                const response = await Vue.axios.post('/rest-auth/login/', dispatchParams)
                //
                commit('LOGIN', response.data.key)
                // sync user
                dispatch('syncUser')
                // show success notification
                dispatch('showWelcomeNotification')
            } catch (err) {
                commit('LOGOUT')
                console.error(err)
                // show success notification
                dispatch(
                    'modal/showNotification',
                    {
                        name: NOTIFICA_ERRORE,
                        title: `Errore durante l'autenticazione`
                    },
                    {root: true}
                )
            }
        },

        async logout({commit, dispatch, getters}: any) {
            commit('LOGOUT')
            // remove user data from state and caches
            dispatch('user/resetEverything', null, {root: true})
            Vue.axios.post('/rest-auth/logout/')
        },

        async checkForSavedToken({getters, state, dispatch}: any) {
            // grabs user token if he was signed in already,
            // and sets axios to use token for every call
            if (getters.isAuthenticated) {
                Vue.axios.defaults.headers.common.Authorization = `Token ${state.token_id}`
                // load user info
                dispatch('user/fetchUserInfo', {}, {root: true})
            }
        },
        async syncUser({dispatch}: any) {
            // load user info
            dispatch('user/fetchUserInfo', {}, {root: true})
        },
        async showWelcomeNotification({dispatch}: any) {
            // load user info
            const userInfo = (await Vue.axios.get('/api/utente_applicazione.json')).data[0]
            // notifica
            dispatch(
                'modal/showNotification',
                {
                    name: NOTIFICA_SUCCESSO,
                    title: `Ciao ${userInfo.user.first_name} ${userInfo.user.last_name}!`
                },
                {root: true}
            )
        },
        async onGoogleSignInSuccess({commit, dispatch}: any, googleUser: any) {
            // `googleUser` is the GoogleUser object that represents the just-signed-in user.
            // See https://developers.google.com/identity/sign-in/web/reference#users
            const authResponse = googleUser.getAuthResponse(true) // etc etc
            try {
                const token = (await Vue.axios.post('/rest-auth/google/', {access_token: authResponse.access_token})).data.key
                commit('LOGIN', token)
                // close modal
                dispatch('modal/showModal', null, {root: true})
                // sync user
                dispatch('syncUser')
                // showWelcomeNotification
                dispatch('showWelcomeNotification')
            } catch (error) {
                console.error(error)
            }
        },
        onGoogleSignInError({commit, dispatch}: any, error: any) {
            // `error` contains any error occurred.
            console.log('OH NOES', error)
        },
        async onFacebookSignInSuccess({commit, dispatch}: any) {
            FB.getLoginStatus(loginStatus => {
                const accessToken = loginStatus.authResponse.accessToken
                Vue.axios.post('/rest-auth/facebook/', {access_token: accessToken}).then(response => {
                    const token = response.data.key
                    commit('LOGIN', token)
                    // close modal
                    dispatch('modal/showModal', null, {root: true})
                    // sync user
                    dispatch('syncUser')
                    // showWelcomeNotification
                    dispatch('showWelcomeNotification')
                })
            })
        },
        onFacebookSignInError(error) {
            console.log('OH NOES', error)
        }
    }
}
